import api from "./api";

export const login = async (email: string, password: string, subdomain?: string, portal?: string) => {
  const res = await api.post("/api/auth/login", {
    email,
    password,
    subdomain,
    portal,
  });
  return res.data;
};

export const forgotPassword = async (email: string, subdomain?: string) => {
  const res = await api.post("/api/auth/forgot-password", {
    email,
    subdomain,
  });
  return res.data;
};

export const resetPassword = async (token: string, newPassword: string) => {
  const res = await api.post("/api/auth/reset-password", {
    token,
    newPassword,
  });
  return res.data;
};

export const validateResetToken = async (token: string) => {
  const res = await api.get(`/api/auth/validate-reset-token?token=${token}`);
  return res.data;
};

export const verifyMfaOtp = async (mfaToken: string, otp: string) => {
  const res = await api.post("/api/auth/mfa/verify-otp", { mfaToken, otp });
  return res.data;
};

export const resendMfaOtp = async (mfaToken: string) => {
  const res = await api.post("/api/auth/mfa/resend-otp", { mfaToken });
  return res.data;
};

export const changePassword = async (currentPassword: string, newPassword: string) => {
  const res = await api.post("/api/auth/change-password", {
    currentPassword,
    newPassword,
  });
  return res.data;
};
